import { useEffect, useState } from 'react';
import { useOtherSettings } from '@namespace/cms';

const getRandomIdx = (arr: string[]) => Math.floor(Math.random() * arr.length);

export const useGameCardsAnimation = (
  gameIdsWithAnimationImage: string[],
  showAnimation: boolean
) => {
  const [currentAnimatedGameId, setCurrentAnimatedGameId] = useState('');
  const { gameImageAnimationDurationSeconds } = useOtherSettings();

  useEffect(() => {
    let intervalId: NodeJS.Timer;
    if (gameIdsWithAnimationImage.length > 0 && showAnimation) {
      setCurrentAnimatedGameId(
        gameIdsWithAnimationImage[getRandomIdx(gameIdsWithAnimationImage)]
      );
      intervalId = setInterval(() => {
        setCurrentAnimatedGameId(
          gameIdsWithAnimationImage[getRandomIdx(gameIdsWithAnimationImage)]
        );
      }, gameImageAnimationDurationSeconds * 1000);
    } else {
      setCurrentAnimatedGameId('');
    }
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [gameIdsWithAnimationImage.length, showAnimation]);

  return currentAnimatedGameId;
};
